import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {EntityDescriptionFactory} from "./entity-description.factory";
import {EntityDescriptionRepository} from "./entity-description.repository";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";

export class EntityDescriptionDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, EntityDescriptionRepository, EntityDescriptionFactory, DomainRequestManager, EntityDescriptionFactory];
}